import { useTranslation } from 'react-i18next';

const LanguageToggle = () => {
  const { i18n } = useTranslation();
  const isAr = i18n.language === 'ar';

  return (
    <div className="flex items-center rounded-full border border-gray-600 overflow-hidden bg-gray-800 flex-shrink-0">
      <button
        type="button"
        onClick={() => i18n.changeLanguage('en')}
        aria-label="Switch to English"
        className={`px-3 py-1.5 text-xs font-black transition-all duration-200 ${
          !isAr
            ? 'bg-red-600 text-white shadow-inner'
            : 'text-gray-400 hover:text-white'
        }`}
      >
        English
      </button>
      <div className="w-px h-4 bg-gray-600" />
      <button
        type="button"
        onClick={() => i18n.changeLanguage('ar')}
        aria-label="التبديل إلى العربية"
        className={`px-3 py-1.5 text-xs font-black transition-all duration-200`}
        style={{
          fontFamily: 'Cairo, system-ui, sans-serif',
          ...(isAr
            ? { backgroundColor: '#dc2626', color: '#fff' }
            : { color: '#9ca3af' }),
        }}
      >
        عربي
      </button>
    </div>
  );
};

export default LanguageToggle;
